import modal from './modules/modal';
import helper from './modules/helper';
import './modules/tabs';
import Select from './modules/select.native';
import './modules/inputs';
import Counter from './modules/counter';
import 'owl';
import 'lightgallery';
import 'lg-thumbnail';
import 'lg-video';
import '../stylus_toolkit/toolkit.styl';
import '../external_css/lightgallery.css';
import '../stylus_theme/theme.styl';
import '../icons';

import smartFilter from './modules/smart-filter';
import './modules/menu-collapse'

if ($('#sm-filter').length) {
    smartFilter();
}

import lastProductsSlider from './modules/last-products-slider';
lastProductsSlider();

/*sliders*/
import { mainSlider } from './modules/main-slider';
import mainProductSlider from './modules/main-product-slider';
import passportSlider from './modules/passport-slider';

/*header*/
import { headerSearch } from './modules/header-search';
import { headerSearchMobile } from './modules/header-search-mobile';
import { mainMenu } from './modules/main-menu';
import { hamburger } from './modules/hamburger';

import { vMenu } from './modules/v-menu';

import ProductGroup from './modules/product-group';

import tooltips from './modules/tooltips';

import dragscroll from 'dragscroll';

import jsForm from './modules/ajax/js-form';
new jsForm('.js-form');

import shopBasket from './modules/shop-basket';

import Notification from './modules/notification';

import orderConfirmation from './modules/order-confirmation';

import shopGallery from './modules/shop-gallery';

import slideNav from './modules/slide-nav';

slideNav('#catalog-slide-nav');
slideNav('#hamburger-slide-nav');

shopGallery();

$('.owl-carousel--default').owlCarousel({
    items: 1,
    dots: true,
    lazyLoad: true,
    nav: true,
    navText: [
        `<svg width="11.115" height="30" viewBox="0 0 7.41 20" version="1.1" aria-hidden="true" class="sst-svg-icon sst-svg-icon--ic-chevron-left">
			<path d="M7.41,5.41L6,4l-6,6l6,6l1.41-1.41L2.83,10L7.41,5.41z" fill-rule="evenodd"></path>
		</svg>
		`,
        `<svg width="11.115" height="30" viewBox="0 0 7.41 20" version="1.1" aria-hidden="true" class="sst-svg-icon sst-svg-icon--ic-chevron-right">
			<path d="M1.41,4L0,5.41L4.58,10L0,14.59L1.41,16l6-6L1.41,4z" fill-rule="evenodd"></path>
		</svg>`,
    ],
});

$('.light-gallery').lightGallery({
    thumbnail: true,
    download: false,
    counter: false,
});

// window.$ = window.jQuery = jquery

/** init selects */
Select();

/** init counters */
Counter();

/**
 * Ошибка в поле ( $ || HTMLelement )
 * let input = $('#input) || document.querySelector('#input')
 * helper.showFieldError(input, 'Текст ошибки')
 */

/**
 * Скрывает элемент ( $ || HTMLelement )
 * let element = $('#element)
 * helper.slideUp(element, 0.5, () => {console.log('end')} )
 */

/**
 * Ширина скроллбара
 * helper.scrollBarWidth()
 */

/**
 * Проверка мобильного браузера
 * helper.isMobile
 */

/**
 * Форматирование чисел
 * helper.formatDecimals(15000000)
 */

/**
 * Склонение
 * helper.declension(155, ['стул', 'стула', 'стульев']))
 */

/**
 * Блокировка страницы
 * helper.freezeDocument()
 */

/**
 * Разблокировка страницы
 * helper.unFreezeDocument()
 */

const SST = {};

Object.defineProperties(SST, {
    // SST.modal({template: 'callbackRequest'})
    modal: { value: modal },

    // SST.helper
    helper: { value: helper },

    // SST.$
    $: { value: $ },
});

Object.defineProperty(window, 'SST', {
    value: SST,
});

(function (ELEMENT) {
    ELEMENT.matches =
        ELEMENT.matches ||
        ELEMENT.mozMatchesSelector ||
        ELEMENT.msMatchesSelector ||
        ELEMENT.oMatchesSelector ||
        ELEMENT.webkitMatchesSelector;
    ELEMENT.closest =
        ELEMENT.closest ||
        function closest(selector) {
            if (!this) return null;
            if (this.matches(selector)) return this;
            if (!this.parentElement) {
                return null;
            } else return this.parentElement.closest(selector);
        };
})(Element.prototype);
